import { LogLevel } from "@azure/msal-browser";

const SSO_TENANT_AUTHORITY =
  "https://login.microsoftonline.com/" + process.env.REACT_APP_SSO_TENET_ID;

// B2C Authority - uses direct authority from .env
const B2C_TENANT_AUTHORITY = process.env.REACT_APP_B2C_AUTHORITY;

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_SSO_CLIENTID,
    authority: SSO_TENANT_AUTHORITY,
    redirectUri: process.env.REACT_APP_SSO_REDIRECTURI || window.location.origin + "/",
    postLogoutRedirectUri: process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URI || window.location.origin + "/",
    knownAuthorities: ["login.microsoftonline.com"],
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level >= LogLevel.Warning) console.warn(message);
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

// B2C Configuration
export const b2cMsalConfig = {
  auth: {
    clientId: process.env.REACT_APP_B2C_CLIENTID,
    authority: B2C_TENANT_AUTHORITY,
    redirectUri: process.env.REACT_APP_B2C_REDIRECTURI || "https://localhost:3000/",
    postLogoutRedirectUri: process.env.REACT_APP_B2C_REDIRECTURI || "https://localhost:3000/",
    knownAuthorities: [
      process.env.REACT_APP_B2C_AUTHORITY_DOMAIN || "goderjb2c.b2clogin.com"
    ]
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level >= LogLevel.Warning) console.warn(message);
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

export const b2cLoginRequest = {
  scopes: ["openid", "profile"]
};

export const apiRequest = {
  scopes: [`api://${process.env.REACT_APP_SSO_CLIENTID}/access_as_user`],
};

export const b2cApiRequest = {
  scopes: ["openid", "profile"]
};